import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="auto-hider"
export default class extends Controller {
  static values = {
    nodes: String
  }

  connect() {
    document.querySelectorAll(this.nodesValue).forEach(element => {
      element.classList.add("d-none")
    })
  }
}
